import React, { useState } from "react";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import { CurrencyConvertion, FormatValueDecimal } from "../../../utils/Validate";

const ProductQuantityTable = ({
    addProduct,
    variantsArray,
    productConfigVariant,
    setAddProduct,
    currencyDetail,
    markErrorShow,
    setMarkErrorShow,
    values,
    factoryOrderRecord,
    isFactoryOrderEdit,
    releaseForm
}) => {
    const [commentOpen, setCommentOpen] = useState("hide");

    const isInCurrentOrder = (item) => item?.isInCurrentOrder !== false;

    const getFactoryReleaseItem = (item) => {
        const factoryOrderProduct = factoryOrderRecord?.products?.find((product) =>
            String(product?.customerOrderProductId) === String(item?.orderProductId ?? item?.quoteProductId ?? item?.id)
        );

        return factoryOrderProduct?.productItems?.find((factoryItem) =>
            String(factoryItem?.customerOrderProductItemId ?? factoryItem?.quoteProductItemId ?? factoryItem?.orderProductItemId ?? factoryItem?.id) ===
            String(item?.id ?? item?.quoteProductItemId ?? item?.orderProductItemId)
        );
    };

    const getReleaseQuantity = (item) => {
        if (!isInCurrentOrder(item)) {
            return 0;
        }

        if (isFactoryOrderEdit) {
            const factoryReleaseItem = getFactoryReleaseItem(item);
            return Number(
                factoryReleaseItem?.currentReleaseQuantity ??
                factoryReleaseItem?.factoryReleasedQuantity ??
                item?.currentReleasedQuantity ??
                0
            );
        }

        return Number(item?.currentReleasedQuantity ?? 0);
    };

    const getReleaseUnitPrice = (item) => {
        const factoryReleaseItem = getFactoryReleaseItem(item);
        return  CurrencyConvertion(
                    Number(factoryReleaseItem?.unitPrice ?? item?.unitPrice) || 0,
                    Number(values?.conversionRate) || 1,
                    currencyDetail?.shortCode
                )
    };

const handleProductChange = (e, productitem) => {
    const { name, value } = e.target;

    setAddProduct(prevProducts =>
        prevProducts.map(item => {
            if (item.sid !== productitem.sid) {
                return item;
            }

            const updatedItem = {
                ...item,
                [name]: value,
            };

            if (name === "currentReleasedQuantity") {
                const qty = isInCurrentOrder(item) ? (Number(value) || 0) : 0;
                const price = Number(item.unitPrice) || 0;

                updatedItem.currentReleasedQuantity = qty;
                updatedItem.currentReleasedQuantityChanged = true;
                updatedItem.factoryReleasedQuantity = qty;
                updatedItem.totalPrice = price * qty;
            }

            if (name === "unitPrice") {
                const price = Number(value) || 0;
                const qty = Number(item.currentReleasedQuantity) || 0;

                updatedItem.totalPrice = price * qty;
            }

            return updatedItem;
        })
    );
};

    const handleItemDeliveryDateChange = (date, productitem) => {
        setAddProduct(prevProducts =>
            prevProducts.map(item =>
                item.sid === productitem.sid
                    ? { ...item, requestedDeliveryDate: date }
                    : item
            )
        );
    };

    const handleNotesChange = (e, productitem, isClear) => {
        const index = addProduct.findIndex(i => i.sid === productitem.sid);
        if (index === -1) return;

        setAddProduct(prev => {
            const newArr = [...prev];
            newArr[index] = { ...prev[index], notes: isClear === true ? "" : e.target.value };
            return newArr;
        });
    };
const getCurrentQty = (item) => {
    if (!isInCurrentOrder(item)) {
        return 0;
    }

    const lpo = Number(item?.lpoQuantity ?? 0);
    const released = Number(item?.factoryReleasedQuantity ?? 0);

    // If quantity was already released in a previous factory order,
    // current release should be the remaining quantity.
    // if (released > 0) {
    //     return Math.max(lpo - released, 0);
    // }

    // First factory order - use the entered/current release quantity
    const current = Number(item?.currentReleasedQuantity ?? 0);

    return Number.isFinite(current) ? current : 0;
};

const totalQuantity = (addProduct || []).reduce(
    (sum, item) => sum + getCurrentQty(item),
    0
);
const grandTotalNet = (addProduct || []).reduce(
    (sum, item) => {
        if (!isInCurrentOrder(item)) {
            return sum;
        }

        const qty = getCurrentQty(item);
        const price = Number(
            isFactoryOrderEdit
                ? getReleaseUnitPrice(item)
                : CurrencyConvertion(
                    Number(item?.unitPrice) || 0,
                    Number(values?.conversionRate) || 1,
                    currencyDetail?.shortCode
                )
        ) || 0;

        return sum + (price * qty);
    },
    0
);

    return (
        <div className="card mt-2 size-quantities-card">
            <div className="card-body">
                <div className="row h-100">
                    <div className="col-md-12 mt-1 d-flex flex-column">
                        <div className="order-size-grid-wrapper">
                            <div className="table-responsive order-size-grid-scroll">
                                <table className="table table-borderless mb-0">
                                    <TableHeader productConfigVariant={productConfigVariant} currencyDetail={currencyDetail} />
                                    <tbody>
                                        {addProduct?.map((productitem, productindex) => (
                                            <TableRow
                                                currencyDetail={currencyDetail}
                                                key={productitem?.sid ?? productindex}
                                                productitem={productitem}
                                                productindex={productindex}
                                                variantsArray={variantsArray}
                                                productConfigVariant={productConfigVariant}
                                                commentOpen={commentOpen}
                                                setCommentOpen={setCommentOpen}
                                                onProductChange={handleProductChange}
                                                onItemDeliveryDateChange={handleItemDeliveryDateChange}
                                                onNotesChange={handleNotesChange}
                                                values={values}
                                                factoryOrderRecord={factoryOrderRecord}
                                                isFactoryOrderEdit={isFactoryOrderEdit}
                                                releaseForm={releaseForm}
                                               
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-footer product-size-grid-footer">
                                {markErrorShow?.show && (
                                    <div className="footer-note footer-note-error">
                                        <i
                                            className="fas fa-exclamation-circle"
                                            aria-hidden="true"
                                        ></i>
                                        <span className="text-danger">{markErrorShow?.errorMessage}</span>
                                    </div>
                                )}

                                <div className="footer-summary">
                                    <span className="size-summary-item">
                                        <span>Total Quantity</span>
                                        <strong>{totalQuantity}</strong>
                                    </span>

                                    <span className="size-summary-item">
                                        <span>Grand Total (Net)</span>
                                        <strong>
                                            {FormatValueDecimal(                                             
                                                   grandTotalNet,                                                  
                                            )}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductQuantityTable;
